module.exports = __webpack_public_path__ + "static/img/fwwd.d95cd2b0.png";